module.exports = __webpack_public_path__ + "img/img_manual3_4.fc7b7114.jpg";